export const stateFieldRequiredCountries = [
  'US', // United States has province
];

export const EU_COUNTRY_CODES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
];

export const US_COUNTRY_CODE = 'US';

export const EU_STATES = [
  {
    us: [
      {
        stateId: '1',
        name: 'Alabama',
        iso: 'AL',
      },
      {
        stateId: '2',
        name: 'Alaska',
        iso: 'AK',
      },
      {
        stateId: '3',
        name: 'Arizona',
        iso: 'AZ',
      },
      {
        stateId: '4',
        name: 'Arkansas',
        iso: 'AR',
      },
      {
        stateId: '5',
        name: 'California',
        iso: 'CA',
      },
      {
        stateId: '6',
        name: 'Colorado',
        iso: 'CO',
      },
      {
        stateId: '7',
        name: 'Connecticut',
        iso: 'CT',
      },
      {
        stateId: '8',
        name: 'Delaware',
        iso: 'DE',
      },
      {
        stateId: '9',
        name: 'District of Columbia',
        iso: 'DC',
      },
      {
        stateId: '10',
        name: 'Florida',
        iso: 'FL',
      },
      {
        stateId: '11',
        name: 'Georgia',
        iso: 'GA',
      },
      {
        stateId: '12',
        name: 'Hawaii',
        iso: 'HI',
      },
      {
        stateId: '13',
        name: 'Idaho',
        iso: 'ID',
      },
      {
        stateId: '14',
        name: 'Illinois',
        iso: 'IL',
      },
      {
        stateId: '15',
        name: 'Indiana',
        iso: 'IN',
      },
      {
        stateId: '16',
        name: 'Iowa',
        iso: 'IA',
      },
      {
        stateId: '17',
        name: 'Kansas',
        iso: 'KS',
      },
      {
        stateId: '18',
        name: 'Kentucky',
        iso: 'KY',
      },
      {
        stateId: '19',
        name: 'Louisiana',
        iso: 'LA',
      },
      {
        stateId: '20',
        name: 'Maine',
        iso: 'ME',
      },
      {
        stateId: '21',
        name: 'Maryland',
        iso: 'MD',
      },
      {
        stateId: '22',
        name: 'Massachusetts',
        iso: 'MA',
      },
      {
        stateId: '23',
        name: 'Michigan',
        iso: 'MI',
      },
      {
        stateId: '24',
        name: 'Minnesota',
        iso: 'MN',
      },
      {
        stateId: '25',
        name: 'Mississippi',
        iso: 'MS',
      },
      {
        stateId: '26',
        name: 'Missouri',
        iso: 'MO',
      },
      {
        stateId: '27',
        name: 'Montana',
        iso: 'MT',
      },
      {
        stateId: '28',
        name: 'Nebraska',
        iso: 'NE',
      },
      {
        stateId: '29',
        name: 'Nevada',
        iso: 'NV',
      },
      {
        stateId: '30',
        name: 'New Hampshire',
        iso: 'NH',
      },
      {
        stateId: '31',
        name: 'New Jersey',
        iso: 'NJ',
      },
      {
        stateId: '32',
        name: 'New Mexico',
        iso: 'NM',
      },
      {
        stateId: '33',
        name: 'New York',
        iso: 'NY',
      },
      {
        stateId: '34',
        name: 'North Carolina',
        iso: 'NC',
      },
      {
        stateId: '35',
        name: 'North Dakota',
        iso: 'ND',
      },
      {
        stateId: '36',
        name: 'Ohio',
        iso: 'OH',
      },
      {
        stateId: '37',
        name: 'Oklahoma',
        iso: 'OK',
      },
      {
        stateId: '38',
        name: 'Oregon',
        iso: 'OR',
      },
      {
        stateId: '39',
        name: 'Pennsylvania',
        iso: 'PA',
      },
      {
        stateId: '40',
        name: 'Rhode Island',
        iso: 'RI',
      },
      {
        stateId: '41',
        name: 'South Carolina',
        iso: 'SC',
      },
      {
        stateId: '42',
        name: 'South Dakota',
        iso: 'SD',
      },
      {
        stateId: '43',
        name: 'Tennessee',
        iso: 'TN',
      },
      {
        stateId: '44',
        name: 'Texas',
        iso: 'TX',
      },
      {
        stateId: '45',
        name: 'Utah',
        iso: 'UT',
      },
      {
        stateId: '46',
        name: 'Vermont',
        iso: 'VT',
      },
      {
        stateId: '47',
        name: 'Virginia',
        iso: 'VA',
      },
      {
        stateId: '48',
        name: 'Washington',
        iso: 'WA',
      },
      {
        stateId: '49',
        name: 'West Virginia',
        iso: 'WV',
      },
      {
        stateId: '50',
        name: 'Wisconsin',
        iso: 'WI',
      },
      {
        stateId: '51',
        name: 'Wyoming',
        iso: 'WY',
      },
    ],
  },
];
